<template>
  <div>
    <v-container grid-list-xl>
      <h3>Name of the icon.</h3>
      <label>Exemples:</label>
      <v-layout wrap>
        <v-flex
          class="text-xs-center pa-2"
          v-for="icon in icons"
          :key="icon"
          xs2
        >
          <v-flex class="pb-0 pa-0" xs12>
            <v-icon color="white">{{ icon }}</v-icon>
          </v-flex>
          <v-flex class="pb-0 pa-0" xs12>
            <span class="caption"></span>
            {{ icon }}
          </v-flex>
        </v-flex>
      </v-layout>
      <v-flex class="pt-4">
        <span>
          For more icon references, please visit
          <a
            class="primary--text"
            href="https://material.io/resources/icons/?style=baseline"
            >material.io</a
          >
        </span>
      </v-flex>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      icons: [
        "mdi-account",
        "mdi-account-group",
        "mdi-alarm",
        "mdi-alert",
        "mdi-bank",
        "mdi-beach",
        "mdi-book-open-variant",
        "mdi-bus",
        "mdi-taxi",
        "mdi-cart",
        "mdi-coffee",
        "mdi-credit-card",
        "mdi-email",
        "mdi-ferry",
        "mdi-file-download",
        "mdi-gas-station",
        "mdi-gift",
        "mdi-hotel",
        "mdi-laptop",
        "mdi-message-bulleted",
        "mdi-package-variant",
        "mdi-pencil",
        "mdi-truck",
        "mdi-wifi",
      ],
    };
  },
  methods: {},
};
</script>

<style lang="stylus"></style>
